import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table, Container, Card } from "react-bootstrap";
// import WhatsAppAPI from "../../api/WhatsAppAPI";
import { ShimmerTable } from "react-shimmer-effects";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import Confirm from "../Confirm";
import Confirm from "../../Confirm";
import AddGroupModal from "./AddGroupModal";
import { Link } from "react-router-dom";
import { NameInitialsAvatar } from 'react-name-initials-avatar';
import { FaTrash, FaEdit, FaPlus } from "react-icons/fa";
import SparkApi from "../../../api/SparkApi";
const Groups = () => {
    const [groups, setGroups] = useState([]);
    const [showHideModel, setShowHideModel] = useState(false);
    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [isSpinner, setIsSpinner] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState([]);
    const [bgColors, setBgColors] = useState(['#d3761f', '#00ad5b', '#debf31', '#239dd1', '#b67eb1', '#d3761f', '#de242f']);
    const [selectedId, setSelectedId] = useState('');
    const [selectedGroupStatus, setSelectedGroupStatus] = useState('');
    let colIndex = 0;

    useEffect(() => {
        fetchGroupRecords();
    }, []);

    const fetchGroupRecords = async () => {
        const result = await SparkApi.fetchGroups();

        if (result.success) {
            setGroups(result.records);
        } else {
            setGroups([]);
        }
        setIsSpinner(true);
    };


    const labels = { beforeSelect: " " };
    const header = [
        {
            title: "Name",
            prop: "name",
            isFilterable: true,
            cell: (row) => (
                <> <Link state={row} to={`/groups/${row.id}`} className="d-flex align-items-center">
                    <NameInitialsAvatar size='30px' textSize='13px'
                        bgColor={fillBgBolor()}
                        borderWidth="0px"
                        textColor="#fff"
                        name={row?.name}
                    />
                    <span className="mx-2">{row.name}</span>
                </Link>
                </>
            ),
        },
        {
            title: "Group Members",
            prop: "members",
            cell: (row) => {
                const members = row.members || [];
                return (
                    <span>
                        {members.length > 0 && (
                            <>
                                {members.slice(0, 5).map((member, index) => (
                                    <span key={index}>
                                        {member.member_firstname + ' ' + member.member_lastname}
                                        {index < members.slice(0, 5).length - 1 && ", "}
                                    </span>
                                ))}
                                {members.length > 5 && "... "}
                            </>
                        )}
                    </span>
                );
            },
        },
        {
            title: "Status",
            prop: "id",
            cell: (row) => (
                <>
                    <Button
                        className="btn-sm mx-2" title="Update status"
                        variant={row.status ? "success" : "danger"}
                        onClick={() => toggleStatusChangeModal(row.id, row.status)}
                    >
                        {row.status ? 'Active' : 'Inactive'}
                    </Button>
                </>
            ),
        }

    ];

    const createGroup = () => {
        setSelectedGroup([]);
        setShowAddGroupModal(true);
    };

    const toggleStatusChangeModal = (id, status) => {
        setSelectedId(id);
        setSelectedGroupStatus(status);
        setShowHideModel(true);
    };



    const changeGroupStatus = async () => {

        try {
            const newStatus = !selectedGroupStatus;

            const response = await SparkApi.changeGroupStatus(selectedId, newStatus);
            if (response.success) {
                setShowHideModel(false);
                toast.success('Group status updated successfully.');
                fetchGroupRecords();
            } else {
                setShowHideModel(false);
                toast.error(response.message);
            }
        } catch (error) {
            //     
        }
    };

    const fillBgBolor = () => {
        colIndex += 1;
        if (colIndex >= bgColors.length)
            colIndex = 0;
        return bgColors[colIndex];
    }

    return (
        <>


            <Container >
                <Row className="mx-5 mb-4">
                    <Card className="p-4 bg-white shadow-sm border-0 rounded-3">
                        <h5 className="mb-2 fw-bold">💡 Quick Guide</h5>
                        <small>
                            Use groups to manage members together, send common messages, and track status easily.
                        </small>
                    </Card>
                </Row>

                <Row className="mx-5 g-0">
                    <Col lg={12} className="mb-3">
                        <Row className="g-0">
                            <Col lg={12}>
                                <div className="bg-white shadow-sm border-0 rounded-3 p-4">
                                    <h5 className="fw-semibold mb-1">📦 All Groups</h5>

                                    {/* {isSpinner ? ( */}
                                    <DatatableWrapper
                                        body={groups}
                                        headers={header}
                                        paginationOptionsProps={{
                                            initialState: {
                                                rowsPerPage: 10,
                                                options: [5, 10, 15, 20],
                                            },
                                        }}
                                    >
                                        <Row className="mb-3">
                                            <Col lg={3} sm={10} xs={10} className="d-flex flex-col justify-content-end align-items-end" >
                                                <Filter className="p-2" />
                                            </Col>
                                            <Col lg={4} sm={2} xs={2} className="d-flex flex-col justify-content-start align-items-start" >
                                                <PaginationOptions labels={labels} />
                                            </Col>
                                            <Col lg={5} sm={12} xs={12} className="mt-2 d-flex flex-col justify-content-end align-items-end">
                                                <Button className="btn-sm text-dark"
                                                    variant="outline-primary mx-2" onClick={createGroup}>
                                                    <FaPlus /> Add New Group
                                                </Button>
                                            </Col>
                                        </Row>

                                        <div className="table-responsive">
                                            <Table striped bordered className="related-list-table" responsive="sm">
                                                <TableHeader />
                                                <TableBody />
                                            </Table>
                                        </div>
                                        <Pagination />
                                    </DatatableWrapper>
                                    {/* ) : (
                                        <ShimmerTable row={10} col={4} />
                                    )} */}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Container>

            {showHideModel && (
                <Confirm
                    show={showHideModel}
                    onHide={() => setShowHideModel(false)}
                    changeGroupStatus={changeGroupStatus}
                    title="Confirm status change?"
                    message="Are you sure you want to change the group's status?"
                    table="group"
                />
            )}


            {showAddGroupModal && (
                <AddGroupModal
                    show={showAddGroupModal}
                    onHide={() => setShowAddGroupModal(false)}
                    fetchGroupRecords={fetchGroupRecords}
                    selectedGroup={selectedGroup}
                />
            )}

            <ToastContainer />
        </>
    );
};

export default Groups;